import * as remoteAction from "../remoteAction";

export type GetShopifyActiveGiftCardsActionSuccess =
  remoteAction.MerchantRemoteResponse<
    "GET_SHOPIFY_ACTIVE_GIFT_CARDS_SUCCESS",
    any
  >;
export type GetShopifyActiveGiftCardsActionFailure =
  remoteAction.MerchantRemoteResponse<
    "GET_SHOPIFY_ACTIVE_GIFT_CARDS_FAILURE",
    any
  >;
export type GetShopifyActiveGiftCardsActionRequest =
  remoteAction.MerchantRemoteResponse<
    "GET_SHOPIFY_ACTIVE_GIFT_CARDS_REQUEST",
    any
  >;

export interface GetShopifyActiveGiftCardsAction
  extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_SHOPIFY_ACTIVE_GIFT_CARDS_REQUEST";
    success: "GET_SHOPIFY_ACTIVE_GIFT_CARDS_SUCCESS";
    failure: "GET_SHOPIFY_ACTIVE_GIFT_CARDS_FAILURE";
  };
}

export function getShopifyActiveGiftCards(): GetShopifyActiveGiftCardsAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_SHOPIFY_ACTIVE_GIFT_CARDS_FAILURE",
      request: "GET_SHOPIFY_ACTIVE_GIFT_CARDS_REQUEST",
      success: "GET_SHOPIFY_ACTIVE_GIFT_CARDS_SUCCESS",
    },
    https: true,
    url: "/shopify/activeAccountCredit/giftCard",
  };
}
